import { Thumbs, A11y, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from '@/components/image';

const MediaThumbnailImages = ({
  images,
  thumbsRef,
  setThumbsSwiper,
  handleThumbClick,
  currentImg,
  title,
}) => {
  return (
    images?.length > 1 && (
      <div className='w-full flex-1 max-sm:mb-6 sm:flex sm:items-center sm:justify-center sm:px-2'>
        <Swiper
          ref={thumbsRef}
          modules={[Thumbs, FreeMode, A11y]}
          onSwiper={setThumbsSwiper}
          slidesPerView='auto'
          spaceBetween={12}
          freeMode={true}
          watchSlidesProgress={true}
          a11y={{
            enabled: true,
            itemRoleDescriptionMessage: 'Thumbnail',
          }}
        >
          {images?.map((info, index) => (
            <SwiperSlide
              key={index}
              className={`max-w-[84px] min-w-[84px] rounded-lg border transition-all sm:rounded-xl ${currentImg === index ? 'border border-blue-500 shadow-md sm:border-2' : 'border-border opacity-70 hover:opacity-100'}`}
            >
              <button
                onClick={() => handleThumbClick(index)}
                aria-label={`View image ${index + 1}`}
                aria-current={currentImg === index}
                className='flex max-h-[84px] min-h-[84px] w-full cursor-pointer items-center justify-center overflow-hidden'
              >
                <Image
                  src={info?.image}
                  className='size-11 object-cover sm:size-14'
                  alt={`${title} thumbnail ${index + 1}`}
                  width={56}
                  height={56}
                />
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    )
  );
};

export default MediaThumbnailImages;
